import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
    Row, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText,
    Button
} from 'reactstrap';
import PaymentTable from './PaymentTable';
import { store, toggleOptionsMenu } from '../../Helper';
import { getPayments, deletePayment } from '../../API';
import { makePayment } from '../Account/Account';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';

function Payments(props) {
    const [layout, setLayout] = useState('table');
    const [searchOptions, setSearchOptions] = useState({ success: 1 });
    const [searchTimeout, setSearchTimeout] = useState(false);
    const searchOptionsRef = useRef(searchOptions);
    const searchTimeoutRef = useRef(searchTimeout);
    const [payments, setPayments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    searchOptionsRef.current = searchOptions;
    searchTimeoutRef.current = searchTimeout;

    //Automatically search when a search option updates (at most evry 500ms).
    useEffect(() => {
        const timeoutSearch = async () => {
            await search();
        };

        const timeout = setTimeout(timeoutSearch, 500);

        return (() => clearTimeout(timeout));
    }, [searchOptions]);

    const search = async () => {
        setIsLoading(true);

        //const searchMinDate = new Date(searchOptionsRef.current.minPaidDate);
        //const searchMaxDate = new Date(searchOptionsRef.current.maxPaidDate);
        //const searchAPIResults = store.payments.filter(p => {
        //    return (!searchOptionsRef.current.identifier || p.feePayments.some(fp => fp.fee.identifier.toLowerCase().includes(searchOptionsRef.current.identifier.toLowerCase())))
        //        && (!searchOptionsRef.current.account || p.feePayments.some(fp => fp.fee.account.name.toLowerCase().includes(searchOptionsRef.current.account.toLowerCase())))
        //        && (!searchOptionsRef.current.accountNumber || p.feePayments.some(fp => fp.fee.account.accountNumber.toLowerCase().includes(searchOptionsRef.current.accountNumber.toLowerCase())))
        //        && (searchOptionsRef.current.success == -1 || (searchOptionsRef.current.success == 1 && p.success) || (searchOptionsRef.current.success == 0 && !p.success))
        //        && (!searchOptionsRef.current.minPaidDate || searchMinDate <= p.paidDate)
        //        && (!searchOptionsRef.current.maxPaidDate || searchMaxDate >= p.paidDate);
        //});
        const searchAPIResults = await getPayments(searchOptionsRef.current);
        setPayments(searchAPIResults.sort((a, b) => a.paidDate < b.paidDate ? 1 : b.paidDate < a.paidDate ? -1 : 0));

        setIsLoading(false);
    };

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
    };

    const deletePaymentRecord = async (paymentId) => {
        if (await deletePayment(paymentId))
            await search();
        else
            console.log('Unable to delete this record.');
    };

    const searchOptionsJSX = (
        <div>
            <Row xs={1} md={2} lg={3} xl={4}>
                <Col>
                    <FormGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-check-square"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input type="select" name="success" value={searchOptions.success} onChange={updateSearch}>
                                <option value={1}>Successful</option>
                                <option value={0}>Unsuccessful</option>
                                <option value={-1}>Any</option>
                            </Input>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-asterisk"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Account Number" name="accountNumber" value={searchOptions.accountNumber || ''} onChange={updateSearch} />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-city"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Account" name="account" value={searchOptions.account || ''} onChange={updateSearch} />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-hashtag"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="EPA ID/Permit Number" name="identifier" value={searchOptions.identifier || ''} onChange={updateSearch} />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <InputGroup className="tooltip-parent">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-calendar-alt"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input type="date" placeholder="Min Paid Date" name="minPaidDate" value={searchOptions.minPaidDate || ''} onChange={updateSearch} />
                            <div className="tooltip-target tooltip-top">
                                Min Date
                                    </div>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <InputGroup className="tooltip-parent">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-calendar-alt"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input type="date" placeholder="Max Paid Date" name="maxPaidDate" value={searchOptions.maxPaidDate || ''} onChange={updateSearch} />
                            <div className="tooltip-target tooltip-top">
                                Check Number
                                    </div>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-hashtag"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="CheckRegister Number" name="CheckNumber" value={searchOptions.CheckNumber || ''} onChange={updateSearch} />
                        </InputGroup>
                    </FormGroup>
                </Col>
            </Row>
            <Row xs={1} md={2} lg={3} xl={4}>
                <Col className="col" md={{ span: 6, offset: 6 }} lg={{ span: 4, offset: 8 }} xl={{ span: 3, offset: 9 }}>
                    <Button className="btn-block btn-icon" color="danr-green" onClick={search}><i className="fas fa-search"></i><span>Search</span></Button>
                </Col>
            </Row>
        </div>
    );

    const searchActionsJSX = window.env.user.userRoles.some(ur => [1, 4].includes(ur.roleID)) ? (
        <div className="search-actions">
            <div onClick={toggleOptionsMenu} className="action-icon action-dropdown">
                <i className="fas fa-ellipsis-h"></i>
                <div className="action-dropdown-menu">
                    <Link className="action-dropdown-menu-item" to='/admin/makepayment'>Make Payment</Link>
                </div>
            </div>
        </div>
    ) : null;

    const tableOptions = {
        fields: {
            success: true,
            type: true,
            details: true,
            amount: true,
            processingFee: true,
            total: true,
            transactionId: true,
            paidDate: true,
            actions: true
        },
        footer: {
            feePaymentTotal: false,
            paymentTotal: true
        },
        actions: {
            add: false,
            view: true,
            edit: true,
            receipt: true,
            delete: true
        },
        details: {
            accountNumber: true,
            account: true,
            identifier: true,
            amount: true,
            CheckNumber: true
        }
    }

    const searchResultsJSX = isLoading ?
        (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>)
        :
        (<PaymentTable options={tableOptions} payments={payments} />);

    return (
        <div id="payments">
            <Row className="title-row">
                <Col>
                    <h1>Payments</h1>
                </Col>
            </Row>
            <Row className="search-row">
                <Col>
                    {searchOptionsJSX}
                </Col>
            </Row>
            <Row className="actions-row">
                <Col>
                    {searchActionsJSX}
                </Col>
            </Row>
            <Row className="results-row">
                <Col>
                    {searchResultsJSX}
                </Col>
            </Row>
        </div>
    );
}

export default Payments;